var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('admin-sidebar'),_vm._v(" "),_c('main',{staticClass:"main-content col",attrs:{"role":"main"}},[_c('nuxt')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }